import React, {useEffect, useRef, useState} from "react";
import Style from "./Style_PastRanking";

import PastBenefits from "../pastRank/PastBenefits";
import GoToVote from "../rank/goToVote/GoToVote";
import PastRankTabList from "../pastRank/PastRankTabList";

// datepicker
import BtnFilledMPrimary from "../button/BtnFilledMPrimary";
import DatePicker from 'react-datepicker';
import ko from "date-fns/locale/ko";
import 'react-datepicker/dist/react-datepicker.css';
import CustomInput from "../input/CustomInput";

const PastMonthlyRanking = () => {
    let current = new Date();
    let oneMonthAgo = new Date(current.setMonth(current.getMonth() - 1));

    const [menu, setMenu] = useState(0);
    const [year, setYear] = useState(0);
    const [month, setMonth] = useState(0);

    const [startDate, setStartDate] = useState(oneMonthAgo);
    const calendar = useRef(null);
    const tabsRef = useRef([]);

    const [scrollPosition, setScrollPosition] = useState(0);
    const updateScroll = () => {
        setScrollPosition(window.scrollY);
    }
    useEffect(()=> {
        window.addEventListener('scroll', updateScroll);
        return () => window.removeEventListener("scroll", updateScroll);
    },[]);

    const confirmMonthDatePicker = () => {
        let date = new Date(startDate);
        let year = date.getFullYear();
        let month = date.getMonth()+1;
        setYear(year);
        setMonth(month);
        console.log(`${menu}, ${year} ${month}`);
        calendar.current.setOpen(false);
    }

    const handlePastRankMenuTab = (menu) => {
        let date = new Date(startDate);
        let year = date.getFullYear();
        let month = date.getMonth()+1;
        setYear(year);
        setMonth(month);
        setMenu(menu);
        console.log(`${menu}, ${year} ${month}`);
    }

    const tabContArr = [
        {
            label: (<Style.PastRankButton className={menu === 0 ? "active" : ""}
                                          onClick={() => handlePastRankMenuTab(0)}>남자스타</Style.PastRankButton>),
            content: <PastRankTabList gender="men" menu="0" year={year} month={month}/>
        },
        {
            label: (<Style.PastRankButton className={menu === 1 ? "active" : ""}
                                          onClick={() => handlePastRankMenuTab(1)}>여자스타</Style.PastRankButton>),
            content: <PastRankTabList gender="women" menu="1" year={year} month={month}/>
        }
    ];

    let today = new Date();
    let sel_month = -1;
    today.setMonth(today.getMonth() + sel_month );
    let todayYear    = today.getFullYear();
    let todayMonth   = ('0' + (today.getMonth() +  1 )).slice(-2);
    let todayDay     = ('0' + today.getDate()).slice(-2);

    return (
        <>
            <Style.PastRankTab>
                <Style.PastRankBar className={scrollPosition < 150 ? "" : "scrolledPastRankTab"}>
                    <DatePicker
                        selected={startDate}
                        onChange={(date) => setStartDate(date)}
                        dateFormat="yyyy.MM"
                        showMonthYearPicker
                        // withPortal
                        minDate={new Date('2022-10-01')}
                        maxDate={new Date(`${todayYear}-${todayMonth}-${todayDay}`)}
                        locale={ko}
                        ref={calendar}
                        popperPlacement="auto"
                        yearItemNumber={1}
                        shouldCloseOnSelect={false}
                        customInput={<CustomInput sortType={"monthly"}/>}
                    >
                        <div className="button-container">
                            <BtnFilledMPrimary className={"btn_ctrl btn_ctrl-confirm"}
                                           onClick={confirmMonthDatePicker}
                                           title={"확인"}/>
                        </div>
                    </DatePicker>
                    <ul>
                        {tabContArr.map((section, index) => {
                            return <div key={index}
                                        ref={(el) => (tabsRef.current[index] = el)}>
                                {section.label}
                            </div>
                        })}
                    </ul>
                </Style.PastRankBar>
                <PastBenefits/>
                <div>
                    {tabContArr[menu].content}
                </div>
            </Style.PastRankTab>
            {/*<GoToVote rankingCategory="일일 순위" title="투표 하러가기"/>*/}
        </>
    )
}

export default PastMonthlyRanking;